import React, { Suspense } from 'react';

// ─────────────────────────────────────────────────────────────────────────
// 시뮬레이터가 내려오는 동안 그 자리에 두는 것.
//
// 시뮬레이터는 필요할 때 받는다(simulatorRegistry 의 React.lazy). 받는 동안 React 는
// 가장 가까운 <Suspense> 의 fallback 을 그리므로, **시뮬을 그리는 자리마다** 이걸로
// 감싼다. 화면 전체를 감싸면 시뮬 하나 받는 동안 주변 UI 까지 통째로 사라진다.
//
// 빈 화면을 두지 않는다 — 학생에게는 "안 열렸다"로 보이고, 그 순간 다시 누른다.
// ─────────────────────────────────────────────────────────────────────────

export function SimFallback({ label = '실습을 준비하고 있습니다' }) {
  return (
    // 들어간 자리를 꽉 채우고 그 가운데에 선다. 자리가 가로로 늘어놓는 틀(flex row)이면
    // 폭을 안 잡은 div 는 글자 폭만큼만 서서 왼쪽 끝에 붙는다 — 로그인한 채 새로고침하면
    // App 의 화면 자리가 그래서 "화면을 준비하고 있습니다"가 왼쪽 끝에 몇 초씩 떠 있었다(2026-09-30 담당자).
    <div
      style={{
        flex: '1 1 auto', alignSelf: 'stretch', width: '100%', boxSizing: 'border-box',
        minHeight: 240, display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexDirection: 'column', gap: 12, padding: 40, color: '#8ba0c0',
        fontFamily: 'Pretendard, system-ui, sans-serif', fontSize: 14,
      }}
    >
      <div
        aria-hidden
        style={{
          width: 30, height: 30, borderRadius: '50%',
          border: '3px solid rgba(139,160,192,.25)', borderTopColor: '#8ba0c0',
          animation: 'simspin 0.9s linear infinite',
        }}
      />
      <span>{label}</span>
      <style>{'@keyframes simspin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}

export default function SimLoading({ children, label }) {
  return <Suspense fallback={<SimFallback label={label} />}>{children}</Suspense>;
}
